import { Heading } from "@/components";
import useAddEdit from "./useAddEdit";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui";
import { editTabs, tabs } from "./consts";
import { routes } from "@/routes/utils";
import { Outlet } from "react-router-dom";

const AddEdit = () => {
  const {
    onBackClick,
    breadcrumbData,
    activeTab,
    addIndex,
    projectData,
    onTabClick,
    id,
    isAdd
  } = useAddEdit();

  return (
    <div className="p-4 md:p-6">
      <div className="flex flex-col lg:flex-row lg:items-center w-full justify-between">
        <div className="flex flex-row items-center justify-between">
          <Heading
            title={breadcrumbData[breadcrumbData.length - 1]?.name || ""}
            showBack
            onBackClick={onBackClick}
            breadcrumbData={breadcrumbData}
          />
        </div>
      </div>

      <Tabs
        value={activeTab}
        defaultValue="project-info"
        className="w-full my-3"
      >
        <TabsList className="gap-x-4 max-w-screen lg:max-w-auto overflow-scroll lg:overflow-none">
          {[...tabs, ...(id && !isAdd ? editTabs : [])]?.map((data: any) => (
            <TabsTrigger
              key={data?.value}
              value={data?.value}
              className="hover:cursor-pointer text-gray-400 px-0 border-0 !shadow-none data-[state=active]:rounded-none data-[state=active]:bg-transparent data-[state=active]:border-b-2 data-[state=active]:border-primary data-[state=active]:text-brown-300 data-[state=active]:font-[700]"
              onClick={() => onTabClick(data.value)}
              disabled={Boolean(
                addIndex && data.value != routes.projectInfo && !projectData
              )}
            >
              {data?.title}
            </TabsTrigger>
          ))}
        </TabsList>
        <TabsContent value={activeTab}>
          <Outlet />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default AddEdit;
